import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { OnlineAisleLayoutComponent } from './layouts/online-aisle-layout.component';
import { RFIDLayoutComponent } from './layouts/rfid-layout.component';

import {
  AdminGuard,
  AuthGuard,
  SupervisorGuard,
  AdminOrSupervisorGuard
} from './guards';

// 404
import { p404Component } from './pages/404.component';
import { PublicLayoutComponent } from './layouts/public-layout.component';

export const routes: Routes = [
  {
    path       : '',
    canActivate: [AuthGuard],
    redirectTo : 'dashboard/orders/all',
    pathMatch  : 'full',
  },
  {
    path     : 'public',
    component: PublicLayoutComponent,
    children: [
      {
        path        : '',
        loadChildren: './public/public.module#PublicModule',
      }
    ]
  },
  {
    path       : 'oa',
    component  : OnlineAisleLayoutComponent,
    canActivate: [AuthGuard],
    data       : {
      title: 'HOME'
    },
    children: [
      {
        path        : 'admin',
        loadChildren: './admin/admin.module#AdminModule',
        canActivate : [AdminOrSupervisorGuard]
      },
      {
        path        : 'dashboard',
        loadChildren: './onlineaisle/onlineaisle.module#OnlineAisleModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'help',
        loadChildren: './help/help.module#HelpModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'profile',
        loadChildren: './profile/profile.module#ProfileModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'reports',
        loadChildren: './reports/reports.module#ReportsModule',
        canActivate : [AuthGuard]
      }
    ]
  },
  {
    path       : '',
    component  : FullLayoutComponent,
    canActivate: [AuthGuard],
    data       : {
      title: 'HOME'
    },
    children: [
      {
        path        : 'admin',
        loadChildren: './admin/admin.module#AdminModule',
        canActivate : [AdminOrSupervisorGuard]
      },
      {
        path        : 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'help',
        loadChildren: './help/help.module#HelpModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'profile',
        loadChildren: './profile/profile.module#ProfileModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'reports',
        loadChildren: './reports/reports.module#ReportsModule',
        canActivate : [AuthGuard]
      },
      // {
      //   path: 'components',
      //   loadChildren: './components/components.module#ComponentsModule',
      //   canActivate: [AuthGuard]
      // },
      // {
      //   path: 'icons',
      //   loadChildren: './icons/icons.module#IconsModule',
      //   canActivate: [AuthGuard]
      // },
      {
        path        : 'forms',
        loadChildren: './forms/forms.module#FormsModule',
        canActivate : [AuthGuard]
      },
      // {
      //   path: 'plugins',
      //   loadChildren: './plugins/plugins.module#PluginsModule',
      //   canActivate: [AuthGuard]
      // },
      // {
      //   path: 'widgets',
      //   loadChildren: './widgets/widgets.module#WidgetsModule',
      //   canActivate: [AuthGuard]
      // },
      // {
      //   path: 'charts',
      //   loadChildren: './chartjs/chartjs.module#ChartJSModule',
      //   canActivate: [AuthGuard]
      // },
      // {
      //   path: 'uikits',
      //   loadChildren: './uikits/uikits.module#UIKitsModule',
      //   canActivate: [AuthGuard]
      // },
    ]
  },
  {
    path       : 'rfid',
    component  : RFIDLayoutComponent,
    canActivate: [AuthGuard],
    data       : {
      title: 'HOME'
    },
    children: [
      {
        path        : 'admin',
        loadChildren: './admin/admin.module#AdminModule',
        canActivate : [AdminOrSupervisorGuard]
      },
      {
        path        : 'dashboard',
        loadChildren: './RFID/rfid.module#RFIDModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'help',
        loadChildren: './help/help.module#HelpModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'profile',
        loadChildren: './profile/profile.module#ProfileModule',
        canActivate : [AuthGuard]
      },
      {
        path        : 'reports',
        loadChildren: './reports/reports.module#ReportsModule',
        canActivate : [AuthGuard]
      }
    ]
  },
  {
    path     : 'pages',
    component: SimpleLayoutComponent,
    data     : {
      title: 'Pages'
    },
    children: [
      {
        path        : '',
        loadChildren: './pages/pages.module#PagesModule',
      }
    ]
  },
  { path: '404', component: p404Component },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/app.routing.ts